module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/profile_incomplete-15f85e0b3a9a3fceea4909cfed62cb18.png";